module.exports = __webpack_public_path__ + "media/images/shared/suppliers/ZF_SACHS-c6774412d7337de4c0a8e9d817882844.jpg";